<template>
  <div class="main">
	  <menus></menus>
    <div class="indexBanner">
      <!-- //banner -->
      <div class="banner">
        <el-carousel>
          <el-carousel-item v-for="(item,index) in banner" :key="index" :interval="500">
            <img
              :src="settings.apiBaseImg + item.image"
              :alt="item.name"
              @click="goBanner(item.url)"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 公司数据 -->
      <div class="companyNumber"></div>
    </div>
    <!-- 产品中心 -->
    <product></product>
    <!-- 新闻 -->
    <news></news>
    <!-- 案例 -->
    <cases></cases>
    <!-- 关于广源 -->
    <about></about>
    <!-- 联系我们 -->
    <concat></concat>
	<footers></footers>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import product from "../components/home/product.vue";
import news from "../components/home/news.vue";
import cases from "../components/home/case.vue";
import about from "../components/home/about.vue";
import concat from "../components/home/concat.vue";
import menus from "../components/home/menu.vue"
import footers from "../components/home/footer.vue"
import request from "../assets/js/request.js";
import qs from "qs";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Swiper,
    SwiperSlide,
    countTo,
    product,
    news,
    cases,
    about,
    concat,
	menus,footers
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 10,
        loop: true,
        speed: 600, //config参数同swiper4,与官网一致
      },
      startVal: 0,
      endVal: 1200,
      banner: [],
    };
  },
  created() {
    request
      .post(
        this.settings.apiBaseUrl + "/api/index/youhuaseo",
        qs.stringify({}),
        {
          headers: {},
        }
      )
      .then((res) => {
        if (res.code == 1) {
        } else {
          this.$message.error(res.msg);
        }
      });
    this.getData();
  },
  methods: {
    getData() {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/banner",
          qs.stringify({
            type: 0,
          }),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.banner = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    goBanner(url) {
      window.open(url);
    },
  },
};
</script>
<style scoped="scoped">
.main {
  width: 100%;
  height: auto;
}

.indexBanner {
  width: 100%;
  height: 950px;
  position: relative;
}

.banner {
  width: 100%;
  height: 740px;
}

.banner img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

/deep/ .el-carousel__container,
/deep/ .el-carousel {
  height: 100%;
}

.companyNumber {
  width: 85%;
  height: 250px;
  margin: -80px auto;
  position: absolute;
  left: 7%;
  background-image: url(../assets/images/home/company.png);
  background-size: 100% 100%;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/main.vue